// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".news[data-v-439a3853]{width:1200px;min-height:500px;margin:auto;overflow:hidden;display:flex;flex-flow:row nowrap;justify-content:space-between;zoom:1}.news .news-wrap[data-v-439a3853]{width:834px;position:relative;margin-top:10px;clear:both}.news .news-container-right[data-v-439a3853]{width:316px;margin-top:10px}.news .news-container-right .hotArticle[data-v-439a3853]{margin:20px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
